const secondaryNav = document.querySelector('#page-header .navigation-list')

if (secondaryNav) {
    // Find the all nav item inside the list and setup the appropriate handlers
    const navItems = secondaryNav.querySelectorAll('.navigation-item')
    // We only want to apply the prevent default on the anchor NOT all anchors with the navigation-item class.
    const navItemsAnchors = secondaryNav.querySelectorAll('.navigation-item > .navigation-anchor')

    const containingElement = document.querySelector('.mega-navigation');

    document.body.addEventListener('click', function( event ){
        if(containingElement && containingElement.contains( event.target ) ){
            // do nothing, click was inside container
        } else {
            // hide autocomplete, click was outside container.
            navItems.forEach((item) => {
                item.classList.remove('active')
            })
        }
    });

    function removeActiveClass(navItem) {
        navItems.forEach((item) => {
            if (item !== navItem) {
                item.classList.remove('active')
            }
        })
    }

    function handleNavItemKeyDown(event) {
        /*const self = this;
        if (event.key === 'Enter') {
            const navItem = self.parentElement;
            const hasMegaNav = navItem.querySelector('.mega-navigation')
            // Remove all active class from existing secondary nav item that isn't the current item.
            removeActiveClass(navItem)
            // Add active class to the item that trigger the event.
            navItem.classList.toggle('active')
            // Check to see if the nav item has secondary level items because if it does it will have a mega-nav menu associated with it.
            if (hasMegaNav) {
                event.preventDefault()
            }
        }*/

        if (event.key === 'Escape') {
            removeActiveClass(navItems);
        }
    }

    function handelMouseover(event) {
        const self = this;
        const navItem = self.parentElement;
        // Remove all active class from existing secondary nav item that isn't the current item.
        removeActiveClass(navItem)
        // Add active class to the item that trigger the event.
        navItem.classList.toggle('active')
    }
    function handleTab(event) {
        const activeElement = document.activeElement;
        //console.log("Current active element now", activeElement);
        linkActiveElement = activeElement.href;
        console.log("Link in Active Element:", linkActiveElement);
        const navItemsArray = Array.from(navItems);
        const lastNavItem = navItemsArray[navItemsArray.length - 1];
        //console.log("Last Navigation Item:", lastNavItem);
        linkLastNavItem = lastNavItem.querySelector('li > a').href;
        console.log("Link in Last Navigation Item:", linkLastNavItem);
        console.log("Clicked Tab", event.key === 'Tab');
        if (event.key === 'Tab' && linkActiveElement === linkLastNavItem) {
            console.log("Reached the Last Navigation Item");
            removeActiveClass(navItems);
        }
        if (event.key === 'Escape') {
            removeActiveClass(navItems);
        }
    }

    if (navItemsAnchors) {
        navItemsAnchors.forEach((anchor) => {
            anchor.addEventListener('keydown', handleNavItemKeyDown)
            anchor.addEventListener('mouseover', handelMouseover)
            anchor.addEventListener('focus', handelMouseover)
        })
    }
    if (navItems) {
        navItems.forEach((item) => {
            item.addEventListener('keydown', handleTab)
        })
    }
}
